/*
 * 路由配置
 * @Author: sunxiaodong
 * @Date: 2018-12-06 14:04:05
 * @Last Modified by: sunxiaodong
 * @Last Modified time: 2018-12-12 09:51:01
 */
import common from "./modules/common";
import permission from "./modules/permission";
import user from "./modules/user";
import getters from "./getters";

const object = require("lodash/fp/object");

import storeIndividuation from "@/store";

const storePrivate = {
    modules: {
        common,
        permission,
        user
    },
    getters
};

const store = object.merge(storePrivate, storeIndividuation);

export default store;
